<template>
  <div :class="carouselClasses">
    <!-- Layout Q - standalone with its own header/footer -->
    <template v-if="layout === 'Q'">
      <div :class="`${baseClass}__container`">
        <div :class="`${baseClass}__header`">
          <h2 :class="`${baseClass}__title carousel-text-white`">
            <span :class="`${baseClass}__dash carousel-text-accent`">—</span>
            {{ title }}
          </h2>
        </div>
        <div :class="`${baseClass}__grid`">
          <router-link
            v-if="displayProducts[0]"
            :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[0].product_id } }"
            @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[0].product_id } })"
            :class="`${baseClass}__card ${baseClass}__card--small ${baseClass}__card--far-left`"
          >
            <div :class="`${baseClass}__image`"><img :src="displayProducts[0].icon_small" :alt="displayProducts[0].title" /></div>
            <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ displayProducts[0].title }}</h3>
          </router-link>
          <div :class="`${baseClass}__stack ${baseClass}__stack--left`">
            <router-link
              v-for="item in displayProducts.slice(1, 3)"
              :key="item.product_id"
              :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: item.product_id } }"
              @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: item.product_id } })"
              :class="`${baseClass}__card ${baseClass}__card--small`"
            >
              <div :class="`${baseClass}__image`"><img :src="item.icon_small" :alt="item.title" /></div>
              <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
            </router-link>
          </div>
          <router-link
            v-if="displayProducts[3]"
            :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[3].product_id } }"
            @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[3].product_id } })"
            :class="`${baseClass}__card ${baseClass}__card--big`"
          >
            <div :class="`${baseClass}__image`"><img :src="displayProducts[3].icon_small" :alt="displayProducts[3].title" /></div>
            <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ displayProducts[3].title }}</h3>
          </router-link>
          <div :class="`${baseClass}__stack ${baseClass}__stack--right`">
            <router-link
              v-for="item in displayProducts.slice(4, 6)"
              :key="item.product_id"
              :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: item.product_id } }"
              @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: item.product_id } })"
              :class="`${baseClass}__card ${baseClass}__card--small`"
            >
              <div :class="`${baseClass}__image`"><img :src="item.icon_small" :alt="item.title" /></div>
              <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
            </router-link>
          </div>
          <router-link
            v-if="displayProducts[6]"
            :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[6].product_id } }"
            @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[6].product_id } })"
            :class="`${baseClass}__card ${baseClass}__card--small ${baseClass}__card--far-right`"
          >
            <div :class="`${baseClass}__image`"><img :src="displayProducts[6].icon_small" :alt="displayProducts[6].title" /></div>
            <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ displayProducts[6].title }}</h3>
          </router-link>
        </div>
        <div :class="`${baseClass}__footer`">
          <router-link
            :to="{ name: 'ProductCategory', params: { type: currentType, title, id: categoryId } }"
            class="btn--outline btn--sm"
            :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']"
          >
            {{ $t('button.seemore') }}
          </router-link>
        </div>
      </div>
    </template>

    <!-- Layout Z - 1-3-1 bento grid -->
    <template v-else-if="layout === 'Z'">
      <div :class="`${baseClass}__container`">
        <div :class="`${baseClass}__header`">
          <h2 :class="`${baseClass}__title`">
            <span :class="`${baseClass}__dash carousel-text-accent`">—</span>
            {{ title }}
          </h2>
          <router-link
            :to="{ name: 'ProductCategory', params: { type: currentType, title, id: categoryId } }"
            class="btn--outline btn--sm"
            :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']"
          >
            {{ $t('button.seemore') }}
          </router-link>
        </div>
        <div :class="`${baseClass}__grid`">
          <!-- Left big card -->
          <router-link
            v-if="displayProducts[0]"
            :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[0].product_id } }"
            @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[0].product_id } })"
            :class="`${baseClass}__card ${baseClass}__card--big`"
          >
            <div :class="`${baseClass}__image`">
              <img :src="displayProducts[0].icon_small" :alt="displayProducts[0].title" />
            </div>
            <div :class="`${baseClass}__card-info`">
              <h3 :class="`${baseClass}__card-title`">{{ displayProducts[0].title }}</h3>
              <button v-if="showButtonCarouselZ" :class="`${baseClass}__btn carousel-btn-success`">
                <span v-if="displayProducts[0].type === 1">{{ $t('button.playGame') }}</span>
                <span v-else-if="displayProducts[0].type === 5">{{ $t('button.playVideo') }}</span>
                <span v-else>{{ $t('button.download') }}</span>
              </button>
            </div>
          </router-link>

          <!-- Center stack (3 small horizontal cards) -->
          <div :class="`${baseClass}__stack`">
            <router-link
              v-for="item in displayProducts.slice(1, 4)"
              :key="item.product_id"
              :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: item.product_id } }"
              @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: item.product_id } })"
              :class="`${baseClass}__card ${baseClass}__card--small`"
            >
              <div :class="`${baseClass}__thumb`">
                <img :src="item.icon_small" :alt="item.title" />
              </div>
              <div :class="`${baseClass}__card-info`">
                <h3 :class="`${baseClass}__card-title`">{{ item.title }}</h3>
                <button v-if="showButtonCarouselZ" :class="`${baseClass}__btn carousel-btn-success`">
                  <span v-if="item.type === 1">{{ $t('button.playGame') }}</span>
                  <span v-else-if="item.type === 5">{{ $t('button.playVideo') }}</span>
                  <span v-else>{{ $t('button.download') }}</span>
                </button>
              </div>
            </router-link>
          </div>

          <!-- Right big card -->
          <router-link
            v-if="displayProducts[4]"
            :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[4].product_id } }"
            @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[4].product_id } })"
            :class="`${baseClass}__card ${baseClass}__card--big`"
          >
            <div :class="`${baseClass}__image`">
              <img :src="displayProducts[4].icon_small" :alt="displayProducts[4].title" />
            </div>
            <div :class="`${baseClass}__card-info`">
              <h3 :class="`${baseClass}__card-title`">{{ displayProducts[4].title }}</h3>
              <button v-if="showButtonCarouselZ" :class="`${baseClass}__btn carousel-btn-success`">
                <span v-if="displayProducts[4].type === 1">{{ $t('button.playGame') }}</span>
                <span v-else-if="displayProducts[4].type === 5">{{ $t('button.playVideo') }}</span>
                <span v-else>{{ $t('button.download') }}</span>
              </button>
            </div>
          </router-link>
        </div>
      </div>
    </template>

    <!-- All other layouts -->
    <template v-else>
      <div v-if="layout === 'F'">
        <img src="../assets/images/carousel-blur.svg" alt="blur" class="carousel-top-blur"/>
        <img src="../assets/images/carousel-blur.svg" alt="blur" class="carousel-bottom-blur"/>
      </div>
      <div v-if="layout === 'W' || layout === 'X'">
        <img src="../assets/images/carousel-lines-left.svg" alt="lines" class="carousel-lines-left"/>
        <img src="../assets/images/carousel-lines-right.svg" alt="lines" class="carousel-lines-right"/>
      </div>
      <div :class="[['E', 'F', 'G', 'U', 'V', 'W', 'X'].includes(layout) ? `${baseClass}__section__box` : usesSwiper? 'section__box' : `${baseClass}__container`, usesSwiper && layout === 'A' ? 'section__box--smToppad' : usesSwiper && !['E', 'F', 'G', 'U', 'V', 'W', 'X'].includes(layout) ? 'section__box--nobg' : '']">
        <div :class="usesSwiper ? (['E', 'F', 'G', 'U', 'V', 'W', 'X'].includes(layout) ? `${baseClass}__header` : 'section__head') : `${baseClass}__header`">
          <h2 :class="usesSwiper ? 'box-title' : `${baseClass}__title carousel-text-white`">
            <span v-if="!usesSwiper" :class="`${baseClass}__dash carousel-text-accent`">—</span>
            <template v-if="!usesSwiper"> </template>{{ title }}
          </h2>
          <div v-if="usesSwiper" class="item-img">
            <router-link
              :to="{
                name: 'ProductCategory',
                params: { type: currentType, title, id: categoryId }
              }"
              class="btn--outline btn--sm"
              :class="[currentLanguage === 'AR' ? 'rtlText' : '']"
            >
              {{ $t('button.seemore') }}
            </router-link>
          </div>
          <router-link
            v-else
            :to="{
              name: 'ProductCategory',
              params: { type: currentType, title, id: categoryId }
            }"
            class="btn--outline btn--sm"
            :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']"
          >
            {{ $t('button.seemore') }}
          </router-link>
        </div>

        <!-- Swiper-based layouts (A, B, C, D, E, F, G, U, V, W, X) -->
        <Swiper v-if="usesSwiper" class="swiper carousel-wrapper" :class="swiperWrapperClass" v-bind="swiperConfig">
          <!-- Layout A, B, C, D, E, F, U, V, W, X -->
          <template v-if="layout !== 'G'">
            <SwiperSlide
              v-for="item in displayProducts"
              :key="item.product_id"
              :class="getSwiperSlideClass(item)"
            >
              <!-- Layout A -->
              <router-link
                v-if="layout === 'A'"
                :to="{
                  name: 'ProductDetails',
                  params: { type: helpers.portal_name, productId: item.product_id }
                }"
                @click="onProductClick($event, {
                  name: 'ProductDetails',
                  params: { type: helpers.portal_name, productId: item.product_id }
                })"
              >
                <div>
                  <div class="item-img">
                    <img :src="item.icon_small" :alt="item.title" />
                  </div>
                  <div class="item-data">
                    <h3 class="data-title">{{ item.title }}</h3>
                    <div class="data-category">{{ item.short_description }}</div>
                  </div>
                </div>
              </router-link>

              <!-- Layout B -->
              <template v-if="layout === 'B'">
                <div
                  class="item-img"
                  @click="onProductClick($event, {
                    name: 'ProductDetails',
                    params: { type: helpers.portal_name, productId: item.product_id }
                    })"
                >
                  <router-link
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    }"
                  >
                    <img :src="item.icon_small" :alt="title" />
                  </router-link>
                </div>
                <div class="item-data">
                  <router-link
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    }"
                    @click="onProductClick($event, {
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    })"
                  >
                    <div>
                      <h3 class="data-title">{{ item.title }}</h3>
                      <div class="data-category">{{ item.short_description }}</div>
                    </div>
                  </router-link>
                  <router-link
                    class="item-btn"
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    }"
                    @click="onProductClick($event, {
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    })"
                  >
                    <div class="btn--next btn--primary btn--sm">
                      <span v-if="item.type === 1" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                        {{ $t('button.playGame') }}
                      </span>
                      <span v-else-if="item.type === 5" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                        {{ $t('button.playVideo') }}
                      </span>
                      <span v-else :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                        {{ $t('button.download') }}
                      </span>
                    </div>
                  </router-link>
                </div>
              </template>

              <!-- Layout C -->
              <template v-if="layout === 'C'">
                <div
                  class="item-img"
                  @click="onProductClick($event, {
                    name: 'ProductDetails',
                    params: { type: helpers.portal_name, productId: item.product_id }
                    })"
                >
                  <router-link
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    }"
                    @click="onProductClick($event, {
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    })"
                  >
                    <img :src="item.icon_small" :alt="title" />
                  </router-link>
                </div>
                <div class="item-data">
                  <router-link
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    }"
                  >
                    <div class="item-data-left">
                      <h3
                        class="data-title"
                        @click="onProductClick($event, {
                          name: 'ProductDetails',
                          params: { type: helpers.portal_name, productId: item.product_id }
                        })"
                      >
                        {{ item.title }}
                      </h3>
                      <div class="data-category">{{ item.short_description }}</div>
                    </div>
                  </router-link>
                    <router-link
                      class="item-btn"
                      :to="{
                        name: 'ProductDetails',
                        params: { type: helpers.portal_name, productId: item.product_id }
                      }"
                      @click="onProductClick($event, {
                        name: 'ProductDetails',
                        params: { type: helpers.portal_name, productId: item.product_id }
                      })"
                    >
                      <div class="btn--primary btn--sm">
                        <span v-if="item.type === 1" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                          {{ $t('button.playGame') }}
                        </span>
                        <span v-else-if="item.type === 5" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                          {{ $t('button.playVideo') }}
                        </span>
                        <span v-else :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                          {{ $t('button.download') }}
                        </span>
                      </div>
                    </router-link>
                </div>
              </template>

              <!-- Layout D -->
              <template v-if="layout === 'D'">
                <div
                  class="item-img"
                  @click="onProductClick($event, {
                    name: 'ProductDetails',
                    params: { type: helpers.portal_name, productId: item.product_id }
                    })"
                >
                  <router-link
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    }"
                    @click="onProductClick($event, {
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    })"
                  >
                    <img :src="item.icon_small" :alt="title" />
                  </router-link>
                </div>
                <div class="item-data">
                  <router-link
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    }"
                  >
                    <div
                      class="data-value"
                      @click="onProductClick($event, {
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                      })"
                    >
                      <h3 class="data-title">{{ item.title }}</h3>
                      <div class="data-category">{{ item.short_description }}</div>
                    </div>
                  </router-link>
                    <router-link
                      class="item-btn"
                      :to="{
                        name: 'ProductDetails',
                        params: { type: helpers.portal_name, productId: item.product_id }
                      }"
                      @click="onProductClick($event, {
                        name: 'ProductDetails',
                        params: { type: helpers.portal_name, productId: item.product_id }
                      })"
                    >
                      <div class="btn--primary btn--sm">
                        <span v-if="item.type === 1" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                          {{ $t('button.playGame') }}
                        </span>
                        <span v-else-if="item.type === 5" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                          {{ $t('button.playVideo') }}
                        </span>
                        <span v-else :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                          {{ $t('button.download') }}
                        </span>
                      </div>
                    </router-link>
                </div>
              </template>

              <!-- Layout E, F, V, W-->
              <template v-if="layout === 'E' || layout === 'F' || layout === 'V' || layout === 'W'">
                <div
                  class="item-img"
                  @click="onProductClick($event, {
                    name: 'ProductDetails',
                    params: { type: helpers.portal_name, productId: item.product_id }
                  })"
                >
                  <router-link
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    }"
                  >
                    <img :src="item.icon_small" :alt="title" />
                  </router-link>
                </div>
                <div class="item-data">
                  <router-link
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                     }"
                    @click="onProductClick($event, {
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    })"
                  >
                    <div>
                      <h3 class="data-title">{{ item.title }}</h3>
                      <div class="data-category">{{ item.short_description }}</div>
                    </div>
                  </router-link>
                  <router-link
                    v-if="layout !== 'E' || showButtonCarouselE !== false"
                    class="item-btn"
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                     }"
                    @click="onProductClick($event, {
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    })"
                  >
                    <div class="btn--next btn--primary btn--sm">
                      <span v-if="item.type === 1" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                        {{ $t('button.playGame') }}
                      </span>
                      <span v-else-if="item.type === 5" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                        {{ $t('button.playVideo') }}
                      </span>
                      <span v-else :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                        {{ $t('button.download') }}
                      </span>
                    </div>
                  </router-link>
                </div>
              </template>

              <!-- Layout U -->
              <template v-if="layout === 'U'">
                <div
                  class="item-img"
                  @click="onProductClick($event, {
                    name: 'ProductDetails',
                    params: { type: helpers.portal_name, productId: item.product_id }
                    })"
                >
                  <router-link
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    }"
                    @click="onProductClick($event, {
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    })"
                  >
                    <img :src="item.icon_small" :alt="title" />
                  </router-link>
                </div>
                <div class="item-data">
                  <router-link
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    }"
                  >
                    <div
                      class="data-value"
                      @click="onProductClick($event, {
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                      })"
                    >
                      <h3 class="data-title">{{ item.title }}</h3>
                    </div>
                  </router-link>
                  <router-link v-if="showButtonCarouselU !== false"
                    class="item-btn"
                    :to="{
                        name: 'ProductDetails',
                        params: { type: helpers.portal_name, productId: item.product_id }
                      }"
                    @click="onProductClick($event, {
                        name: 'ProductDetails',
                        params: { type: helpers.portal_name, productId: item.product_id }
                      })"
                  >
                    <div class="btn--primary btn--sm btn--next">
                        <span v-if="item.type === 1" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                          {{ $t('button.playGame') }}
                        </span>
                      <span v-else-if="item.type === 5" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                          {{ $t('button.playVideo') }}
                        </span>
                      <span v-else :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                          {{ $t('button.download') }}
                        </span>
                    </div>
                  </router-link>
                </div>
              </template>

              <!-- Layout X -->
              <template v-if="layout === 'X'">
                <div class="card-overlay"></div>
                <div
                  class="item-img"
                  @click="onProductClick($event, {
                    name: 'ProductDetails',
                    params: { type: helpers.portal_name, productId: item.product_id }
                  })"
                >
                  <router-link
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    }"
                  >
                    <img :src="item.icon_small" :alt="title" />
                  </router-link>
                </div>
                <div class="item-data">
                  <h3 class="data-title">{{ item.title }}</h3>
                  <div class="play-button">
                    <img src="../assets/images/play.svg" alt="Play" class="play-icon" />
                  </div>
                </div>
              </template>
            </SwiperSlide>
          </template>

          <!-- Layout G -->
          <template v-if="layout === 'G'">
            <SwiperSlide v-if="displayProducts.length > 0" class="carousel-item-large">
              <div class="card--large">
                <div
                  class="item-img"
                  @click="onProductClick($event, {
                    name: 'ProductDetails',
                    params: { type: helpers.portal_name, productId: displayProducts[0].product_id }
                  })"
                >
                  <router-link
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: displayProducts[0].product_id }
                    }"
                  >
                    <img
                        :src="displayProducts[0].icon_small"
                        :alt="displayProducts[0].title"
                        @error="imageLoadError(displayProducts[0])"
                    />
                  </router-link>
                </div>
                <div class="item-data">
                  <router-link
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: displayProducts[0].product_id }
                    }"
                    @click="onProductClick($event, {
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: displayProducts[0].product_id }
                    })"
                  >
                    <h3 class="data-title">{{ displayProducts[0].title }}</h3>
                  </router-link>
                  <router-link
                    class="carousel-g__item-btn"
                    :to="{
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: displayProducts[0].product_id }
                    }"
                    @click="onProductClick($event, {
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: displayProducts[0].product_id }
                    })"
                  >
                    <div>
                      <span v-if="displayProducts[0].type === 1" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                        {{ $t('button.playGame') }}
                      </span>
                      <span v-else-if="displayProducts[0].type === 5" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                        {{ $t('button.playVideo') }}
                      </span>
                      <span v-else :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                        {{ $t('button.download') }}
                      </span>
                    </div>
                    </router-link>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide v-if="displayProducts.length > 1" class="carousel-item-grid">
              <div class="cards-grid">
                <div
                  class="card--small"
                  v-for="item in displayProducts.slice(1, 7)"
                  :key="item.product_id"
                >
                  <div
                    class="item-img"
                    @click="onProductClick($event, {
                      name: 'ProductDetails',
                      params: { type: helpers.portal_name, productId: item.product_id }
                    })"
                  >
                    <router-link
                      :to="{
                        name: 'ProductDetails',
                        params: { type: helpers.portal_name, productId: item.product_id }
                      }"
                    >
                      <img :src="item.icon_small" :alt="item.title" @error="imageLoadError(item)" />
                    </router-link>
                  </div>

                    <div class="item-data">
                      <router-link
                        :to="{
                          name: 'ProductDetails',
                          params: { type: helpers.portal_name, productId: item.product_id }
                        }"
                        @click="onProductClick($event, {
                          name: 'ProductDetails',
                          params: { type: helpers.portal_name, productId: item.product_id }
                        })"
                      >
                        <h3 class="data-title">{{ item.title }}</h3>
                      </router-link>
                        <router-link
                          class="carousel-g__item-btn"
                          :to="{
                            name: 'ProductDetails',
                            params: { type: helpers.portal_name, productId: item.product_id }
                          }"
                          @click="onProductClick($event, {
                            name: 'ProductDetails',
                            params: { type: helpers.portal_name, productId: item.product_id }
                          })"
                        >
                          <div>
                            <span v-if="item.type === 1" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                              {{ $t('button.playGame') }}
                            </span>
                            <span v-else-if="item.type === 5" :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                              {{ $t('button.playVideo') }}
                            </span>
                            <span v-else :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']">
                              {{ $t('button.download') }}
                            </span>
                          </div>
                        </router-link>
                    </div>
                </div>
              </div>
            </SwiperSlide>
          </template>
        </Swiper>

        <!-- Grid-based layouts (H, I, J, K, L, M, N, O, P, S, Y) -->
        <template v-else>
          <!-- Layout S - bento: big, 2 stacked, big -->
          <div v-if="layout === 'S'" :class="`${baseClass}__grid`">
            <router-link
              v-if="displayProducts[0]"
              :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[0].product_id } }"
              @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[0].product_id } })"
              :class="`${baseClass}__card ${baseClass}__card--big`"
            >
              <div :class="`${baseClass}__thumbnail`">
                <img :src="displayProducts[0].icon_small" :alt="displayProducts[0].title" />
                <div :class="`${baseClass}__overlay`">
                  <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ displayProducts[0].title }}</h3>
                  <div :class="`${baseClass}__play-button`">
                    <img src="../assets/images/play.svg" alt="Play" :class="`${baseClass}__play-icon`" />
                  </div>
                </div>
              </div>
            </router-link>
            <div :class="`${baseClass}__stack`">
              <router-link
                v-for="item in displayProducts.slice(1, 3)"
                :key="item.product_id"
                :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: item.product_id } }"
                @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: item.product_id } })"
                :class="`${baseClass}__card ${baseClass}__card--small`"
              >
                <div :class="`${baseClass}__thumbnail`">
                  <img :src="item.icon_small" :alt="item.title" />
                  <div :class="`${baseClass}__overlay`">
                    <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
                    <div :class="`${baseClass}__play-button`">
                      <img src="../assets/images/play.svg" alt="Play" :class="`${baseClass}__play-icon`" />
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <router-link
              v-if="displayProducts[3]"
              :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[3].product_id } }"
              @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[3].product_id } })"
              :class="`${baseClass}__card ${baseClass}__card--big`"
            >
              <div :class="`${baseClass}__thumbnail`">
                <img :src="displayProducts[3].icon_small" :alt="displayProducts[3].title" />
                <div :class="`${baseClass}__overlay`">
                  <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ displayProducts[3].title }}</h3>
                  <div :class="`${baseClass}__play-button`">
                    <img src="../assets/images/play.svg" alt="Play" :class="`${baseClass}__play-icon`" />
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <!-- Layout Y - bento: 2 stacked, big, 2 stacked -->
          <div v-if="layout === 'Y'" :class="`${baseClass}__grid`">
            <div :class="`${baseClass}__stack`">
              <router-link
                v-for="item in displayProducts.slice(0, 2)"
                :key="item.product_id"
                :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: item.product_id } }"
                @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: item.product_id } })"
                :class="`${baseClass}__card ${baseClass}__card--small`"
              >
                <div :class="`${baseClass}__thumbnail`">
                  <img :src="item.icon_small" :alt="item.title" />
                  <div :class="`${baseClass}__overlay`">
                    <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
                    <div :class="`${baseClass}__play-button`">
                      <img src="../assets/images/play.svg" alt="Play" :class="`${baseClass}__play-icon`" />
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <router-link
              v-if="displayProducts[2]"
              :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[2].product_id } }"
              @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: displayProducts[2].product_id } })"
              :class="`${baseClass}__card ${baseClass}__card--big`"
            >
              <div :class="`${baseClass}__thumbnail`">
                <img :src="displayProducts[2].icon_small" :alt="displayProducts[2].title" />
                <div :class="`${baseClass}__overlay`">
                  <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ displayProducts[2].title }}</h3>
                  <div :class="`${baseClass}__play-button`">
                    <img src="../assets/images/play.svg" alt="Play" :class="`${baseClass}__play-icon`" />
                  </div>
                </div>
              </div>
            </router-link>
            <div :class="`${baseClass}__stack`">
              <router-link
                v-for="item in displayProducts.slice(3, 5)"
                :key="item.product_id"
                :to="{ name: 'ProductDetails', params: { type: helpers.portal_name, productId: item.product_id } }"
                @click="onProductClick($event, { name: 'ProductDetails', params: { type: helpers.portal_name, productId: item.product_id } })"
                :class="`${baseClass}__card ${baseClass}__card--small`"
              >
                <div :class="`${baseClass}__thumbnail`">
                  <img :src="item.icon_small" :alt="item.title" />
                  <div :class="`${baseClass}__overlay`">
                    <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
                    <div :class="`${baseClass}__play-button`">
                      <img src="../assets/images/play.svg" alt="Play" :class="`${baseClass}__play-icon`" />
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>

          <!-- All other grid layouts -->
          <div v-else :class="gridClasses">
            <router-link
              v-for="(item, index) in displayProducts"
              :key="item.product_id"
              :to="{
                name: 'ProductDetails',
                params: { type: helpers.portal_name, productId: item.product_id }
              }"
              @click="onProductClick($event, {
                name: 'ProductDetails',
                params: { type: helpers.portal_name, productId: item.product_id }
              })"
              :class="getCardClasses(index)"
            >
              <!-- Layout H -->
              <div v-if="layout === 'H'" :class="`${baseClass}__thumbnail carousel-bg-black carousel-gradient-overlay`">
                <img :src="item.icon_small" :alt="item.title" />
                <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
                <div :class="`${baseClass}__play-button`">
                  <img src="../assets/images/icons/play.png" alt="Play" :class="`${baseClass}__play-icon`" />
                </div>
              </div>

              <!-- Layout a -->
              <div v-if="layout === 'a'" :class="`carousel-h2__thumbnail`">
                <img :src="item.icon_small" :alt="item.title" />
                <div :class="`carousel-h2__overlay`">
                  <h3 :class="`carousel-h2__card-title`">{{ item.title }}</h3>
                  <div :class="`carousel-h2__play-button`">
                    <span :class="`carousel-h2__play-triangle`"></span>
                  </div>
                </div>
              </div>

              <!-- Layout I -->
              <div v-if="layout === 'I'">
                <div :class="`${baseClass}__image carousel-bg-dark`">
                  <img :src="item.icon_small" :alt="item.title" />
                </div>
                <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
              </div>

              <!-- Layout J -->
              <div v-if="layout === 'J'" :class="`${baseClass}__thumbnail carousel-bg-black carousel-gradient-overlay`">
                <img :src="item.icon_small" :alt="item.title" />
                <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
                <button :class="`${baseClass}__play-button carousel-btn-success`">{{ $t('button.playVideo') }}</button>
              </div>

              <!-- Layout K -->
              <div v-if="layout === 'K'">
                <div :class="`${baseClass}__image`">
                  <img :src="item.icon_small" :alt="item.title" />
                </div>
                <div :class="`${baseClass}__info`">
                  <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
                  <button :class="`${baseClass}__download-button carousel-btn-success`">{{ $t('button.download') }}</button>
                </div>
              </div>

              <!-- Layout L -->
              <div v-if="layout === 'L'" style="display: flex; flex-direction: column; height: 100%;">
                <div :class="`${baseClass}__image carousel-bg-dark`">
                  <img :src="item.icon_small" :alt="item.title" />
                </div>
                <div style="flex: 1; display: flex; flex-direction: column; justify-content: space-between;">
                  <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
                  <button :class="`${baseClass}__play-button carousel-btn-success`">{{ $t('button.playGame') }}</button>
                </div>
              </div>

              <!-- Layout R -->
              <div v-if="layout === 'R'" style="display: flex; flex-direction: column; height: 100%;">
                <div :class="`${baseClass}__image`">
                  <img :src="item.icon_small" :alt="item.title" />
                </div>
                <div style="flex: 1; display: flex; flex-direction: column; justify-content: space-between;">
                  <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
                  <button :class="`${baseClass}__download-button carousel-btn-success`">{{ $t('button.download') }}</button>
                </div>
              </div>

              <!-- Layout T (like R but with Play button) -->
              <div v-if="layout === 'T'" style="display: flex; flex-direction: column; height: 100%;">
                <div :class="`carousel-r__image`">
                  <img :src="item.icon_small" :alt="item.title" />
                </div>
                <div style="flex: 1; display: flex; flex-direction: column; justify-content: space-between;">
                  <h3 :class="`carousel-r__card-title carousel-text-white`">{{ item.title }}</h3>
                  <button :class="`carousel-r__download-button carousel-btn-success`">{{ $t('button.playGame') }}</button>
                </div>
              </div>

              <!-- Layout M - Large cards -->
              <div v-if="layout === 'M' && index < 3" style="display: flex; flex-direction: column; height: 100%;">
                <div :class="`${baseClass}__image carousel-bg-dark`">
                  <img :src="item.icon_small" :alt="item.title" />
                </div>
                <div :class="`${baseClass}--large__info`">
                  <h3 :class="`${baseClass}--large__card-title carousel-text-white`">{{ item.title }}</h3>
                  <button :class="`${baseClass}--large__download-button carousel-btn-success`">{{ $t('button.playGame') }}</button>
                </div>
              </div>

              <!-- Layout M - Small cards -->
              <div v-if="layout === 'M' && index >= 3" style="display: flex; flex-direction: column; height: 100%;">
                <div :class="`${baseClass}__image carousel-bg-dark`">
                  <img :src="item.icon_small" :alt="item.title" />
                </div>
                <div style="flex: 1; display: flex; flex-direction: column; justify-content: space-between;">
                  <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
                  <button :class="`${baseClass}__play-button carousel-btn-success`">{{ $t('button.playGame') }}</button>
                </div>
              </div>

              <!-- Layout N -->
              <div v-if="layout === 'N'">
                <div :class="`${baseClass}__image`">
                  <img :src="item.icon_small" :alt="item.title" />
                </div>
                <div :class="`${baseClass}__info`">
                  <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
                </div>
              </div>

              <!-- Layout O -->
              <div v-if="layout === 'O'">
                <div :class="`${baseClass}__image`">
                  <img :src="item.icon_small" :alt="item.title" />
                </div>
                <div :class="`${baseClass}__info`">
                  <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
                  <div :class="`${baseClass}__play-button`">
                    <img src="../assets/images/play.svg" alt="Play" :class="`${baseClass}__play-icon`" />
                  </div>
                </div>
              </div>

              <!-- Layout P -->
              <div v-if="layout === 'P'">
                <div :class="`${baseClass}__image`">
                  <img :src="item.icon_small" :alt="item.title" />
                </div>
                <h3 :class="`${baseClass}__card-title carousel-text-white`">{{ item.title }}</h3>
              </div>
            </router-link>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Pagination, Autoplay, Grid } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/grid'
import { helpers } from '../helper/portal_config'
import EventBus from '../helper/event_bus'

export default {
  name: 'BaseCarousel',
  components: { Swiper, SwiperSlide },
  props: {
    products: { type: Array, required: true },
    title: { type: String, required: true },
    categoryId: { type: [String, Number], required: true },
    layout: { type: String, required: true, validator: (v) => ['A', 'B', 'C', 'D', 'E', 'F','G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a'].includes(v) },
    reverse: { type: Boolean, default: false },
    showButtonCarouselE: { type: Boolean, default: true },
    showButtonCarouselU: { type: Boolean, default: true },
    showButtonCarouselZ: { type: Boolean, default: false }
  },
  data() {
    return {
      currentType: null,
      currentLanguage: ''
    }
  },
  computed: {
    ...mapGetters({ isLoggedIn: 'globals/isLoggedIn' }),
    baseClass() {
      if (this.layout === 'a') return 'carousel-h2'
      return `carousel-${this.layout.toLowerCase()}`
    },
    carouselClasses() {
      const swiperLayouts = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'U', 'V', 'W', 'X']
      if (swiperLayouts.includes(this.layout)) {
        const layoutClasses = {
          A: 'section__inner section__inner--noRightpad section__inner--noLeftpad',
          B: 'section__inner section__inner--noRightpad',
          C: 'section__inner section__inner--noRightpad',
          D: 'section__inner section__inner--noRightpad',
          E: 'carousel-e__section__inner',
          F: 'carousel-f__section__inner',
          G: 'carousel-g__section__inner',
          U: 'carousel-u__section__inner',
          V: 'carousel-v__section__inner',
          W: 'carousel-w__section__inner',
          X: 'carousel-x__section__inner'
        }
        return layoutClasses[this.layout]
      }
      const bg = ['H', 'J', 'M', 'N'].includes(this.layout) ? 'carousel-bg-black' : ['Q', 'T', 'a'].includes(this.layout) ? '' : 'carousel-bg-transparent'
      return `${this.baseClass} ${bg}`
    },
    gridClasses() {
      return `${this.baseClass}__grid`
    },
    usesSwiper() {
      return ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'U', 'V', 'W', 'X'].includes(this.layout)
    },
    swiperWrapperClass() {
      const classes = {
        A: 'carousel-wrapper--nopad',
        B: 'carousel-wrapper--nopad',
        C: 'carousel-wrapper--smpad',
        D: 'carousel-wrapper--smpad',
        E: '',
        F: '',
        G: 'carousel-wrapper--grid',
        U: '',
        V: '',
        W: '',
        X: ''
      }
      return [
        classes[this.layout] || '',
        this.layout === 'G' && this.reverse ? 'carousel-wrapper--reverse' : ''
      ]
    },
    swiperConfig() {
      const configs = {
        A: {
          modules: [Navigation, Pagination, Autoplay],
          loop: false,
          slidesPerView: 1.8,
          spaceBetween: 15,
          slidesOffsetAfter: 20,
          breakpoints: {
            400: { slidesPerView: 2.1 },
            667: { slidesPerView: 3.2, spaceBetween: 15 },
            767: { slidesPerView: 3.5, spaceBetween: 20 },
            1200: {
              slidesOffsetAfter: 0,
              grabCursor: false,
              touchRatio: 0,
              slidesPerView: 7
            }
          }
        },
        B: {
          loop: false,
          slidesPerView: 1.5,
          spaceBetween: 15,
          slidesOffsetAfter: 30,
          breakpoints: {
            480: { slidesPerView: 2.2 },
            667: { slidesPerView: 2.6, spaceBetween: 15 },
            767: { slidesPerView: 3.5, spaceBetween: 15 },
            1200: {
              slidesOffsetAfter: 0,
              slidesPerView: 5,
              grabCursor: false,
              touchRatio: 0,
              spaceBetween: 25
            }
          }
        },
        C: {
          modules: [Grid],
          loop: false,
          slidesPerView: 1.1,
          spaceBetween: 20,
          slidesPerGroup: 1,
          slidesOffsetAfter: 100,
          grid: { rows: 3, fill: 'row' },
          breakpoints: {
            667: { slidesPerView: 1.8, grid: { rows: 3, fill: 'row' } },
            767: { slidesPerView: 2.2, grid: { rows: 3, fill: 'row' } },
            1200: {
              slidesPerView: 3,
              grid: { rows: 2, fill: 'row' },
              slidesOffsetAfter: 0,
              grabCursor: false,
              touchRatio: 0,
              spaceBetween: 20
            }
          }
        },
        D: {
          modules: [Grid],
          loop: false,
          slidesPerView: 1.3,
          spaceBetween: 15,
          slidesOffsetAfter: 100,
          grid: { rows: 2, fill: 'row' },
          breakpoints: {
            667: { slidesPerView: 1.9, grid: { rows: 2, fill: 'row' } },
            767: { slidesPerView: 2.5, grid: { rows: 2, fill: 'row' } },
            1200: {
              slidesPerView: 3,
              grid: { rows: 2, fill: 'row' },
              slidesOffsetAfter: 0,
              grabCursor: false,
              touchRatio: 0,
              spaceBetween: 20
            },
            1600: {
              slidesPerView: 3,
              grid: { rows: 2, fill: 'row' },
              slidesOffsetAfter: 0,
              grabCursor: false,
              touchRatio: 0,
              spaceBetween: 20
            }
          }
        },
        E: {
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 0,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          watchOverflow: true
        },
        F: {
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 0,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          watchOverflow: true
        },
        G: {
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 0,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          watchOverflow: true
        },
        U: {
          modules: [Grid],
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 0,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          grid: { rows: 2, fill: 'row' },
          watchOverflow: true
        },
        V: {
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 0,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          watchOverflow: true
        },
        W: {
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 0,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          watchOverflow: true
        },
        X: {
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 0,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          watchOverflow: true
        },
      }
      return configs[this.layout] || {}
    },
    isBookType() {
      return this.helpers.portal_name === 'Carefizz'
    },
    displayProducts() {
      const limits = { G: 7, H: 6, a: 4, I: 8, J: 4, K: 3, L: 5, M: 8, N: 3, O: 4, P: 6, Q: 7, R: 6, S: 4, T: 6, U: 6, Y: 5, Z: 5 }
      return limits[this.layout] ? this.products.slice(0, limits[this.layout]) : this.products
    }
  },
  methods: {
    onProductClick(e, link) {
      if (!this.isLoggedIn) {
        e.preventDefault()
        EventBus.$emit?.('SHOW_SIGNIN_MODAL', link) || EventBus.emit?.('SHOW_SIGNIN_MODAL', link)
      }
    },
    getSwiperSlideClass(item) {
      const layoutClasses = {
        A: this.isBookType ? 'carousel-item card--v1 card--ebook' : 'carousel-item card--v1',
        B: this.isBookType ? 'carousel-item card--v2 card--ebook' : 'carousel-item card--v2',
        C: this.isBookType ? 'carousel-item card--v3 card--ebook' : 'carousel-item card--v3',
        D: this.isBookType ? 'carousel-item card--v4 card--ebook' : 'carousel-item card--v4',
        E: 'carousel-item card--v2',
        F: 'carousel-item card--v2',
        U: 'carousel-item card--v4',
        V: 'carousel-item card--v2',
        W: 'carousel-item card--v2',
        X: 'carousel-item card--v2'
      }
      return layoutClasses[this.layout] || ''
    },
    getProductType() {
      const menu = this.helpers.menu || []
      menu.forEach((item) => {
        if (item.isActive === true) this.currentType = item.type
      })
    },
    setCurrentLanguage() {
      const { host } = window.location
      const country = host.split('.')[0].slice(0, 2).toUpperCase()
      const map = helpers.countryDefaultLanguage || {}
      this.currentLanguage = (map.hasOwnProperty(country) ? map[country] : country).toUpperCase()
    },
    getCardClasses(index) {
      const base = `${this.baseClass}__card`
      let cardClasses = `${base}`

      if (['I', 'M', 'K', 'L', 'N', 'O'].includes(this.layout)) {
        cardClasses += ` carousel-shadow-hover`
      }

      if (['I', 'M'].includes(this.layout)) {
        const isLarge = index < 3
        cardClasses += ` ${base}--${isLarge ? 'large' : 'small'}`
      }

      if (['N', 'M'].includes(this.layout)) {
        cardClasses += ` carousel-card-bg`
      }

      return cardClasses
    }
  },
  created() {
    this.helpers = helpers
    this.getProductType()
    this.setCurrentLanguage()
  }
}
</script>

<style src="../assets/styles/carousels.css"></style>
<style src="../assets/styles/carousels_theme_colours.css"></style>
